import React from 'react';
import { Grid } from 'semantic-ui-react';
import classnames from 'classnames';

export const ChangeBalanceSummary = props => {
  const { balance } = props;
  const updatedBalanceClassName = classnames({
    'text--error': balance.updatedValue < 0,
  });

  return (
    <Grid>
      <Grid.Row columns={6}>
        <Grid.Column className="column--label" width={4}>
          BALANCE
        </Grid.Column>
        <Grid.Column className="column--currency" width={3}>
          {balance.currentValue.toFixed(2)}
        </Grid.Column>
        <Grid.Column width={1} />
        <Grid.Column width={4} />
        <Grid.Column width={1} />
        <Grid.Column className="column--currency" width={3}>
          <span className={updatedBalanceClassName}>
            {balance.updatedValue.toFixed(2)}
          </span>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};



// WEBPACK FOOTER //
// ./src/pages/accountsetup/components/changebalance/ChangeBalanceSummary.js